<ng-select [formControl]="control" [items]="field.options" bindLabel="text" bindValue="value" [placeholder]="field.placeholder || ''">
  <ng-template ng-option-tmp let-item="item" *ngIf="field.iconTemplate">
    <fa-icon [icon]="['fab', item.text]"></fa-icon>
  </ng-template>
</ng-select>